(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.TheAmericanCollege",
                {
                    url: "/TheAmericanCollege",
                    component: "tac",
                    PageTitle: "The American College",
                    requiredPermissions: "AmericanCollege:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("tac",
        {
            templateUrl: "App/Resources/TheAmericanCollege/tac.html",
            controller: tacCtrl,
            bindings: {
                states: "<"
            }
        });

    tacCtrl.$inject = ["amplitudeService"];

    function tacCtrl(amplitudeService) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };
    }
})(window.app, window.angular); // jshint ignore:line